export const registration = {
  hero: {
    title: 'REGISTRATION',
    subtitle: 'Secure your spot in Montenegro\'s premier mountain race',
  },
  pricing: {
    title: 'REGISTRATION FEES',
    skyrace: 'SINJAVINA SKYRACE - 40KM',
    miniSkyrace: 'SINJAVINA MINI SKYRACE - 10KM',
    early: {
      title: 'EARLY REGISTRATION',
      deadline: 'Until March 1, 2026',
      badge: 'BEST VALUE',
    },
    standard: {
      title: 'STANDARD REGISTRATION',
      deadline: 'Until April 30, 2026',
    },
    late: {
      title: 'LATE REGISTRATION',
      deadline: 'Until May 15, 2026',
      badge: 'LIMITED SPOTS',
    },
    buttonSkyrace: 'REGISTER NOW - SKYRACE',
    buttonMini: 'REGISTER NOW - MINI SKYRACE',
  },
  dates: {
    title: 'KEY DATES',
    march1: {
      date: 'MARCH 1, 2026',
      event: 'Early registration deadline',
      detail: 'Last day for discounted rates',
    },
    april30: {
      date: 'APRIL 30, 2026',
      event: 'Standard registration closes',
      detail: 'Prices increase after this date',
    },
    may15: {
      date: 'MAY 15, 2026',
      event: 'Final registration deadline',
      detail: 'No registrations accepted after this date',
    },
    june5: {
      date: 'JUNE 5, 2026',
      event: 'Bib collection in Mojkovac',
      detail: '15:00 - 21:00h (location TBA)',
    },
    june6: {
      date: 'JUNE 6, 2026',
      event: 'RACE DAY',
      detail: 'Start: 08:00h - Motel Ravnjak, Bistrica',
    },
  },
  included: {
    title: 'YOUR RACE PACKAGE INCLUDES',
    bib: {
      title: 'Race Bib',
      description: 'Personalized race number',
    },
    shirt: {
      title: 'Technical T-Shirt',
      description: 'Official event apparel',
    },
    marking: {
      title: 'Trail Marking',
      description: 'Fully marked course with maps',
    },
    aid: {
      title: 'Aid Stations',
      description: 'Multiple refreshment points',
    },
    medal: {
      title: 'Finisher Medal',
      description: 'For all who complete within time limit',
    },
    meal: {
      title: 'Post-Race Meal',
      description: 'Hot meal after finish',
    },
  },
  cta: {
    title: 'READY TO TAKE ON THE CHALLENGE?',
    button: 'COMPLETE YOUR REGISTRATION',
  },
};